// extracted by mini-css-extract-plugin
export default {"add-widget":"ReportBlockAdd_add-widget__-zj+w","bordered":"ReportBlockAdd_bordered__XRCfh","blocks":"ReportBlockAdd_blocks__z7PlF","block":"ReportBlockAdd_block__0gPRL"};